import {Easing, interpolate, spring} from 'remotion';

export const T = {
  bg: '#060B09',
  surface: '#0D1813',
  inset: '#08110D',
  gold: '#E5C358',
  goldLight: '#F4DE8C',
  text: '#F2EDE2',
  muted: '#A5B7AC',
  green: '#10B981',
  rose: '#F26174',
  amber: '#F5A623',
  border: 'rgba(229,195,88,.28)',
};

export const reveal = (frame: number, start = 0, length = 24) =>
  interpolate(frame, [start, start + length], [0, 1], {
    extrapolateLeft: 'clamp', extrapolateRight: 'clamp',
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });

export const settle = (frame: number, delay = 0) => spring({
  frame: Math.max(0, frame-delay), fps: 30,
  config: {damping: 25, stiffness: 100, mass: 1},
});

export const formatNumber = (n: number) => Math.round(n).toLocaleString('en-US');
